/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BonusAccountRespVo
 */
export interface BonusAccountRespVo {
    /**
     * 当前余额（净额模型，同user_wallet.amount：不含冻结金额，即可用余额）
     * @type {number}
     * @memberof BonusAccountRespVo
     */
    balance?: number;
    /**
     * 冻结金额（待确认支付单占用，冻结时已从余额转出）
     * @type {number}
     * @memberof BonusAccountRespVo
     */
    freezeAmount?: number;
    /**
     * 可用额度（=balance，净额模型下余额本身即可用；保留字段便于前端直取）
     * @type {number}
     * @memberof BonusAccountRespVo
     */
    availableAmount?: number;
    /**
     * 可用账单类型集合（billType数组，空=全部不可用）
     * @type {Array<number>}
     * @memberof BonusAccountRespVo
     */
    availableBillTypes?: Array<number>;
}

/**
 * Check if a given object implements the BonusAccountRespVo interface.
 */
export function instanceOfBonusAccountRespVo(value: object): value is BonusAccountRespVo {
    return true;
}

export function BonusAccountRespVoFromJSON(json: any): BonusAccountRespVo {
    return BonusAccountRespVoFromJSONTyped(json, false);
}

export function BonusAccountRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BonusAccountRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'balance': json['balance'] == null ? undefined : json['balance'],
        'freezeAmount': json['freezeAmount'] == null ? undefined : json['freezeAmount'],
        'availableAmount': json['availableAmount'] == null ? undefined : json['availableAmount'],
        'availableBillTypes': json['availableBillTypes'] == null ? undefined : json['availableBillTypes'],
    };
}

export function BonusAccountRespVoToJSON(json: any): BonusAccountRespVo {
    return BonusAccountRespVoToJSONTyped(json, false);
}

export function BonusAccountRespVoToJSONTyped(value?: BonusAccountRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'balance': value['balance'],
        'freezeAmount': value['freezeAmount'],
        'availableAmount': value['availableAmount'],
        'availableBillTypes': value['availableBillTypes'],
    };
}

